import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["mentionType"];
var _mentionStyle, _templateObject;
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { themed, useGlobalTheme } from '@atlaskit/theme/components';
import { B400, B200, N500, DN800, DN100, DN80, N30A, DN30, N20 } from '@atlaskit/theme/colors';
import { MentionType } from '../../types';
import { forwardRef } from 'react';
var mentionStyle = (_mentionStyle = {}, _defineProperty(_mentionStyle, MentionType.SELF, {
  background: themed({
    light: "var(--ds-background-brand-bold, ".concat(B400, ")"),
    dark: "var(--ds-background-brand-bold, ".concat(B200, ")")
  }),
  borderColor: 'transparent',
  text: themed({
    light: "var(--ds-text-inverse, ".concat(N20, ")"),
    dark: "var(--ds-text-inverse, ".concat(DN30, ")")
  }),
  hoveredBackground: themed({
    light: "var(--ds-background-brand-bold-hovered, ".concat(B400, ")"),
    dark: "var(--ds-background-brand-bold-hovered, ".concat(B200, ")")
  }),
  pressedBackground: themed({
    light: "var(--ds-background-brand-bold-pressed, ".concat(B400, ")"),
    dark: "var(--ds-background-brand-bold-pressed, ".concat(B200, ")")
  })
}), _defineProperty(_mentionStyle, MentionType.RESTRICTED, {
  background: 'transparent',
  borderColor: themed({
    light: "var(--ds-border-bold, ".concat(N500, ")"),
    dark: "var(--ds-border-bold, ".concat(DN80, ")")
  }),
  text: themed({
    light: "var(--ds-text, ".concat(N500, ")"),
    dark: "var(--ds-text, ".concat(DN100, ")")
  }),
  hoveredBackground: 'transparent',
  pressedBackground: 'transparent'
}), _defineProperty(_mentionStyle, MentionType.DEFAULT, {
  background: themed({
    light: "var(--ds-background-neutral, ".concat(N30A, ")"),
    dark: "var(--ds-background-neutral, ".concat(DN80, ")")
  }),
  borderColor: 'transparent',
  text: themed({
    light: "var(--ds-text-subtle, ".concat(N500, ")"),
    dark: "var(--ds-text-subtle, ".concat(DN800, ")")
  }),
  hoveredBackground: themed({
    light: "var(--ds-background-neutral-hovered, ".concat(N30A, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat(DN80, ")")
  }),
  pressedBackground: themed({
    light: "var(--ds-background-neutral-pressed, ".concat(N30A, ")"),
    dark: "var(--ds-background-neutral-pressed, ".concat(DN80, ")")
  })
}), _mentionStyle);
var getStyle = function getStyle(_ref, property) {
  var mentionType = _ref.mentionType,
    theme = _ref.theme;
  var obj = mentionStyle[mentionType][property];
  return typeof obj === 'string' ? obj : obj({
    theme: theme
  });
};
var PrimitiveMention = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var mentionType = _ref2.mentionType,
    other = _objectWithoutProperties(_ref2, _excluded);
  var theme = useGlobalTheme();
  return jsx("span", _extends({
    ref: ref,
    css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          display: inline;\n          border: 1px solid ", ";\n          background: ", ";\n          color: ", ";\n          border-radius: 20px;\n          cursor: pointer;\n          padding: 0 0.3em 2px 0.23em;\n          line-height: 1.714;\n          font-size: 1em;\n          font-weight: normal;\n          word-break: break-word;\n          &:hover {\n            background: ", ";\n          }\n          &:active {\n            background: ", ";\n          }\n        "])), getStyle({
      theme: theme,
      mentionType: mentionType
    }, 'borderColor'), getStyle({
      theme: theme,
      mentionType: mentionType
    }, 'background'), getStyle({
      theme: theme,
      mentionType: mentionType
    }, 'text'), getStyle({
      theme: theme,
      mentionType: mentionType
    }, 'hoveredBackground'), getStyle({
      theme: theme,
      mentionType: mentionType
    }, 'pressedBackground'))
  }, other));
});
export default PrimitiveMention;